var localizedContent = false;
var getData = require('./getdata')(MBGF.mbfa_apibase);

function translate(content, next) {
    getLocalizedContent( function(localizedContent) {

        var re = /\{\{.*?\}\}/gi;

        allMatches = content.match(re);

        if (allMatches) {

            for (var i = 0, ii = allMatches.length; i < ii; i++) {

                var matchString = allMatches[i];

                var stringId = matchString.replace(/[\{\}]/g, '');
                var stringInfo = stringId.split(".");
                var labelId = "";

                if( localizedContent[stringId] && localizedContent[stringId].length > 0 ) {
                    var newContent = localizedContent[stringId];
                    var replaceRe = new RegExp(matchString, "g");
                    content = content.replace(replaceRe, newContent);
                }

            }

        }

        if( typeof next == 'function' ) {
            next(content);
        }
        else {
            return content;
        }
    })
}

function getLocalizedContent(next){
    getData('translations', function(localizedContentString) {
        var localizedContent;
        try {
            localizedContent = JSON.parse(localizedContentString)
        }
        catch(e) {
            localizedContent = {};
        }

        if( typeof next == 'function' ) {
            next(localizedContent);
        }
        else {
            return localizedContent;
        }
    })
}

module.exports = {
    translate: translate,
    localizedContent: getLocalizedContent
};



// WEBPACK FOOTER //
// ./js-src/markdown-editor/scripts/localization.js